<template>
	<v-row
		align="center"
		justify="center"

	>
		<v-col cols="11">
			<slot />
		</v-col>
	</v-row>
</template>
<script>

	export default {
		name: "page",
		components: {},
		props: [],
		data () {
			return {};
		},
	};
</script>

<style scoped>

</style>
